<template>
  <div class="order">
    <GlobTopNav title="订单详情"> </GlobTopNav>

    <div class="pop" v-if="lodingshow"><van-loading type="spinner" /></div>
    <div class="van-content">
      <div class="header">
        <div class="titles">
          <span v-if="status == 0">待支付</span>
          <span v-if="status == 1">待发货</span>
          <span v-if="status == 2 && notall == false">
            {{ datas.refund_status == 1 ? ' 部分退款' : datas.refund_status == 2 ? '全部退款' : '已发货'  }}
          </span>
          <span v-if="status == 2 && notall == true">
            {{ datas.refund_status == 1 ? ' 部分退款' : datas.refund_status == 2 ? '全部退款' : '部分发货'  }}
            </span>
          <span v-if="status == -1">已取消</span>
          <p class="float-right">
            <img src="./../../../assets/img/order-dzf.png" v-if="status == 0" />
            <img src="./../../../assets/img/order-dfh.png" v-if="status == 1" />
            <img src="./../../../assets/img/order-dsh.png" v-if="status == 2" />
            <img src="./../../../assets/img/order-yqx.png" v-if="status == -1" />
          </p>
        </div>
      </div>
      <div class="sitebox" v-if="dummy != 2 && dummy != 3">
        <img src="./../../../assets/img/order-dw.svg" alt="" />
        <div class="van-cell__title">
          <span class="cell-left">
            <span>
              <span>{{ datas.consignee }} </span>
              <span style="margin-left: 0.1rem">{{ datas.mobile }}</span>
            </span>
            <!-- <van-icon name="arrow" class="cell-left-icon" /> -->
          </span>
          <p>{{ address }}</p>
        </div>
      </div>
      <div v-if="dummy == 3" :class="dummy == 3 ? 'margin_b0' : ''">
        <div v-if="dummy == 3" class="van-cell van-hairline sitebox">
          <!--<i style="height: .4rem;line-height: .4rem;" class="van-icon iconfont dianziqiaquan icon-dianziqiaquan"></i>-->
          <div class="van-cell__title">
            <span style="line-height: 0.4rem">收货人手机号码：{{ datas.z_mobile }}</span>
          </div>
        </div>
      </div>
      <div v-if="dummy == 2" :class="dummy == 2 ? 'margin_b0' : ''">
        <div v-if="dummy == 2" class="van-cell van-hairline sitebox">
          <!--<i style="height: .4rem;line-height: .4rem;" class="van-icon iconfont dianziqiaquan icon-dianziqiaquan"></i>-->
          <div class="van-cell__title">
            <span style="line-height: 0.4rem">通知号码：{{ datas.z_mobile }}</span>
          </div>
        </div>
      </div>
      <!--多个物流-->
      <van-cell-group v-if="tab == false" v-for="items in datas1" :key="items">
        <div v-for="item in items" :key="item.id">
          <van-card class="van-cell van-hairline goodsonelist">
            <router-link
              slot="thumb"
              class="goodsimgbox"
              :to="{ path: '/goodslist/goods', query: { id: item.id } }"
            >
              <img :src="item.image" onerror="src='/static/errorimg1.png'" />
            </router-link>
            <div @click="godetail(item.id)" slot="title" class="van-card-title">
              <div class="ellipseal">
                <span class="tagbox">
                  <span class="tag xl" v-if="items.source == 4"> 一乡一物 </span>
                  <span class="tag xl" v-if="items.source == 3">卡券</span>
                  <span class="tag zc" v-if="items.source == 2">直充</span>
                  <span plain class="tag jd" v-if="items.source == 1">优选</span>
                  <span class="tag yx" v-if="items.source == 6">严选</span>
                </span>
                {{ item.name }}
              </div>
            </div>
            <div slot="desc" class="van-card-desc theme-col">
              <span class="float-left">
                <span v-if="item.point">{{ item.point }}{{ unit }}</span>
                <span v-if="item.cash">
                  <span>
                    <span v-if="item.point">&nbsp;+&nbsp;</span>{{ item.cash }}
                  </span>
                  <span>元</span>
                </span>
              </span>
              <span class="float-right">× {{ item.nums }}</span>
            </div>
          </van-card>
          <div class="van-cell">
            <div class="text-right1" style="width: 100%">
              <!--<van-button size="small" class="theme-bg radius4 theme-bd" v-if="status == -1&&item.status!=-1&& dummy!=2 && dummy!=3" @click="delOrder(item.id_order)">删除订单</van-button>-->
              <!--<van-button size="small" class="radius4 " v-if="is_cancel>0 && dummy!=2 && dummy!=3 " @click="cancelOrder(item.id_order,item.status+1)">取消订单</van-button>-->
              <!--&lt;!&ndash;<van-button size="small" class="theme-bg radius4 theme-bd" v-if="datas.cami_mi!= ''"  @click="showCardmi(datas.cami_mi,datas.cami_ka)">查看卡密</van-button>&ndash;&gt;-->
              <!--<van-button size="small" class="theme-bg radius4 theme-bd" v-if="status == 0" @click="payOrder(item.id_order)">去支付</van-button>-->

              <router-link
                v-if="dummy != 2 && dummy != 3 && item.company_id != 0"
                :to="{ path: '/user/myorder/logistics', query: { orderid: item.company_id } }"
              >
                <van-button size="small" class="check-logistics">查看物流</van-button>
              </router-link>
            </div>
          </div>
        </div>
      </van-cell-group>
      <!--一个物流-->
      <van-cell-group v-if="tab == true">
        <van-card
          class="van-cell van-hairline goodsonelist"
          v-for="items in datas.products"
          :key="items.id"
        >
          <router-link
            slot="thumb"
            class="goodsimgbox"
            :to="{ path: '/goodslist/goods', query: { id: items.id } }"
          >
            <img :src="items.image" onerror="src='/static/errorimg1.png'" />
          </router-link>
          <div @click="godetail(items.id)" slot="title" class="van-card-title">
            <div class="ellipseal">
              <span class="tagbox">
                <span class="tag xl" v-if="items.source == 4"> 一乡一物 </span>
                <span class="tag xl" v-if="items.source == 3">卡券</span>
                <span class="tag zc" v-if="items.source == 2">直充</span>
                <span plain class="tag jd" v-if="items.source == 1">优选</span>
                <span class="tag yx" v-if="items.source == 6">严选</span>
              </span>
              {{ items.name }}
            </div>
          </div>
          <div slot="desc" class="van-card-desc theme-col">
            <span class="float-left">
              <span v-if="Number(items.point)">{{ items.point }}{{ unit }}</span>
              <span v-if="items.cash">
                <span><span v-if="Number(items.point)">&nbsp;+&nbsp;</span>{{ items.cash }}</span>
                  <span>元</span>
                </span>
              </span>
            <span class="float-right">× {{ items.nums }}</span>
          </div>
        </van-card>
        <div class="van-cell">
          <div class="text-right1" style="width: 100%">
            <router-link
              v-if="dummy != 2 && dummy != 3 && datas.products[0].company_id != 0"
              :to="{
                path: '/user/myorder/logistics',
                query: { orderid: datas.products[0].company_id }
              }"
            >
              <van-button class="check-logistics">查看物流</van-button>
            </router-link>
          </div>
        </div>
      </van-cell-group>

      <div class="totalPart" style="margin-bottom: 0">
        <div class="van-cell van-hairline">
          <div class="van-cell__title"><span>订单总额</span></div>
          <div class="van-cell__value theme-col">
            <span v-if="datas.totalpoints">{{ datas.totalpoints }}{{ unit }}</span>
            <span v-if="datas.total_cash">
              <span><span v-if="datas.totalpoints">&nbsp;+&nbsp;</span>{{ datas.total_cash }}</span>
              <span>元</span>
            </span>
          </div>
        </div>
      </div>
      <div class="total-num">
        <div class="serial-number" style="padding-bottom: 0">
          <p class="order-num">订单编号：{{ datas.ordersn }}</p>
          <p class="order-num">下单时间：{{ time(datas.time) }}</p>
          <div class="order-num">
            备注：
            <div v-html="datas.memo != '' ? datas.memo : '无'"></div>
          </div>
        </div>
      </div>
    </div>
    <div id="botbtnbox" v-if="status == -1 || is_cancel > 0 || status == 0">
      <van-button
        size="small"
        class="order-btn"
        v-if="status == -1"
        @click="delOrder(datas.id_order)"
        >删除订单</van-button
      >
      <van-button
        size="small"
        class="order-btn"
        v-if="is_cancel > 0"
        @click="cancelOrder(datas.id_order, datas.status + 1)"
        >取消订单</van-button
      >
      <van-button
        size="small"
        class="order-btn to-payfor"
        v-if="status == 0"
        @click="payOrder(datas.id_order)"
        >去支付</van-button
      >
    </div>
  </div>
</template>

<script>
import pay from "@/mixins/pay.js";
import TopNav from "@/components/topnav";
export default {
  name: "order",
  components: {
    TopNav
  },
  mixins: [pay],
  computed: {
    unit: function() {
      return this.$store.state.unitinfo.name;
    }
  },
  data() {
    return {
      datas: "",
      datas1: [],
      id: this.$route.query.id,
      type: this.$route.query.type,
      status: "",
      address: "",
      dummy: "", //是否是虚拟商品
      lodingshow: true,
      is_cancel: "",
      length: 0,
      tab: true,
      notall: false,
      btn: false
    };
  },
  methods: {
    goBack: function() {
      history.back(-1);
    },
    godetail: function(id) {
      this.$router.push({ path: "/goodslist/goods", query: { id: id } });
    },
    onClickRight() {
      this.$refs.TopNav.topnavPlay();
    },
    time: function(timestamp) {
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      var h = date.getHours() + ":";
      var m = date.getMinutes() + ":";
      var s;
      if (date.getSeconds() < 10) {
        s = "0" + date.getSeconds();
      } else {
        s = date.getSeconds();
      }
      return Y + M + D + h + m + s;
    },
    getDatas: function() {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      var _this = this;
      this.$api.get(
        "order/orders/information",
        {
          id_example: mallid,
          token_user: isUser,
          id_order: this.id,
          status: this.type
        },
        res => {
          if (res.data.code == "100") {
            this.datas = res.data.data;
            this.dummy = res.data.data.products[0].source;
            this.is_cancel = res.data.data.is_cancel;
            this.status = res.data.data.status;
            var products = res.data.data.products;
            if (res.data.data.town_str == "") {
              this.address =
                res.data.data.province_str +
                res.data.data.city_str +
                res.data.data.county_str +
                res.data.data.address;
            } else {
              this.address =
                res.data.data.province_str +
                res.data.data.city_str +
                res.data.data.county_str +
                res.data.data.town_str +
                res.data.data.address;
            }
            var n = products[0].company_id;
            var arr = [];
            var arr1 = [];
            $.each(products, function(index, item) {
              if (item.company_id == n) {
                var siteObj = {
                  id: item.id,
                  name: item.name,
                  tel: item.phone,
                  image: item.image,
                  nums: item.nums,
                  point: item.point,
                  cash: item.cash,
                  company_id: item.company_id,
                  status: item.status
                };
                arr.push(siteObj);
                _this.length++;
              } else {
                var siteObj = {
                  id: item.id,
                  name: item.name,
                  tel: item.phone,
                  image: item.image,
                  nums: item.nums,
                  point: item.point,
                  cash: item.cash,
                  company_id: item.company_id,
                  status: item.status
                };
                arr1.push(siteObj);
              }
              if (item.company_id == 0) {
                //部分发货
                _this.notall = true;
              }
            });
            if (_this.length == products.length) {
              _this.tab = true; //一个物流
            } else {
              _this.tab = false;
            }
            if (arr1.length != 0) {
              _this.datas1.push(arr1);
            }
            if (arr.length != 0) {
              _this.datas1.push(arr);
            }
            _this.lodingshow = false;
          } else {
            this.$toast(res.data.message);
          }
        }
      );
    },
    //去支付
    payOrder: function(id) {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确认支付该订单？"
        })
        .then(() => {
          if (this.btn == false) {
            this.btn = true;
            this.wxPay(id);
          }
        })
        .catch(() => {
          // on cancel
        });
    },
    //删除订单
    delOrder: function(id, index) {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      this.$dialog
        .confirm({
          title: "提示",
          message: "确认删除该订单？"
        })
        .then(() => {
          this.$api.post(
            "order/orders/delete",
            { id_example: mallid, token_user: isUser, id_order: id },
            res => {
              if (res.data.code == "100") {
                this.$toast(res.data.message);
                history.back(-1);
              } else {
                if (res.data.message == "token验证失败") {
                  this.$dialog
                    .confirm({
                      title: "提示 ",
                      message: "您还未登录是否去登录？"
                    })
                    .then(() => {
                      this.$router.push({ name: "NoteLogin" });
                    })
                    .catch(() => {});
                } else {
                  this.$toast(res.data.message);
                }
              }
            }
          );
        })
        .catch(() => {
          // on cancel
        });
    },
    //取消订单
    cancelOrder: function(id, type) {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      this.$dialog
        .confirm({
          title: "提示",
          message: "确认取消该订单？"
        })
        .then(() => {
          this.$api.post(
            "order/orders/cancel",
            {
              id_example: mallid,
              token_user: isUser,
              id_order: id,
              type: type
            },
            res => {
              if (res.data.code == "100") {
                this.$toast(res.data.message);
                this.lodingshow = true;
                this.datas = "";
                this.datas1 = [];
                this.getDatas();
              } else {
                if (res.data.message == "token验证失败") {
                  this.$dialog
                    .confirm({
                      title: "提示 ",
                      message: "您还未登录是否去登录？"
                    })
                    .then(() => {
                      this.$router.push({ name: "NoteLogin" });
                    })
                    .catch(() => {});
                } else {
                  this.$toast(res.data.message);
                }
              }
            }
          );
        })
        .catch(() => {
          // on cancel
        });
    },
    showCardmi: function(mess, num) {
      var s = "";
      if (num != 0) {
        s = "卡号:" + num;
      }
      this.$dialog.confirm({
        title: "卡密信息",
        message: "卡密:" + mess + s
      });
    }
  },

  mounted() {
    this.getDatas();
  }
};
</script>

<style lang="less">
.order {
  width: 100%;
  min-height: 100vh;
  background-color: rgba(245, 245, 245, 1);
  .van-button__content {
    color: #e23331 !important;
  }
  .van-content {
    .titles {
      width: 100%;
      height: 1.86rem;
      box-sizing: border-box;
      padding: 0 0.3rem;
      background-color: rgba(212, 35, 35, 1);
      background-image: url("./../../../assets/img/order-bg.png");
      background-size: 100%;
      background-position: 0 0;
      background-repeat: no-repeat;
      display: flex;
      align-items: center;
      justify-content: space-between;

      span {
        font-size: 0.36rem;
        font-weight: 600;
        color: #ffffff;
        line-height: 0.5rem;
      }

      .float-right {
        width: 1.8rem;
        height: 1.8rem;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .sitebox {
      width: 100%;
      height: 2.02rem;
      background: #ffffff;
      box-sizing: border-box;
      padding: 0 0.3rem;
      display: flex;
      align-items: center;

      img {
        width: 0.6rem;
        height: 0.6rem;
        margin-right: 0.2rem;
      }

      .van-cell__title {
        .cell-left {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .cell-left-icon {
            font-size: 0.24rem;
            color: rgba(38, 38, 38, 0.3);
            font-weight: bold;
          }
        }
        span {
          font-size: 0.32rem;
          font-weight: 500;
          color: #262626;
          line-height: 0.44rem;
        }
        p {
          font-size: 0.26rem;
          font-weight: 400;
          color: #262626;
          line-height: 0.36rem;
        }
      }
    }

    .van-cell {
      .text-right1 {
        display: flex;
        justify-content: flex-end;

        .check-logistics {
          width: 1.6rem;
          height: 0.52rem;
          border-radius: 0.4rem;
          border: 0.02rem solid #fe6047;
          font-size: 0.24rem;
          font-weight: 400;
          color: #fe5c42;
          line-height: 0.34rem;
        }
      }
    }

    .goodsonelist {
      margin-top: 0.2rem;

      &::after {
        border: none !important;
      }

      .goodsimgbox {
        width: 2.2rem;
        height: 2.2rem;
        img {
          width: 100%;
          height: 100%;
        }
      }

      .ellipseal {
        font-size: 0.26rem;
        font-weight: 400;
        color: #262626;
        line-height: 0.42rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -moz-box-orient: vertical;
        box-orient: vertical;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        overflow: hidden;
      }

      .van-card__content {
        position: relative;

        .van-card-desc {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: absolute;
          bottom: 0.2rem;

          .float-left {
            font-size: 0.28rem;
            font-weight: 400;
            color: #262626;
          }

          .float-right {
            font-size: 0.24rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #929292;
          }
        }
      }
    }

    .totalPart {
      .van-cell {
        padding: 0.36rem 0.3rem;
        border-bottom: 0.02rem solid #f5f5f5;

        .van-cell__title {
          font-size: 0.28rem;
          font-weight: bold;
          color: rgba(38, 38, 38, 0.8);
          line-height: 0.48rem;
        }

        .van-cell__value {
          font-size: 0.28rem;
          font-weight: 400;
          color: #fe5c42;
          line-height: 0.4rem;
        }
      }
    }

    .total-num {
      box-sizing: border-box;
      padding: 0 0.3rem;
      background-color: #fff;
      padding-bottom: 0.26rem;

      .serial-number {
        .order-num {
          padding-top: 0.26rem;
          font-size: 0.28rem;
          font-weight: 400;
          color: rgba(38, 38, 38, 0.5);
          line-height: 0.48rem;
          display: flex;
        }
      }
    }
  }

  #botbtnbox {
    width: 100%;
    height: 1.18rem;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 0;

    .order-btn {
      width: 2.5rem;
      height: 0.8rem;
      background: #fdf5f5;
      border-radius: 0.5rem;
      border: 0.02rem solid #e23331;
      font-size: 0.24rem;
      font-weight: 400;
      line-height: 0.8rem;
      text-align: center;
      color: #262626;
      margin-left: 0.1rem;
      color: rgba(226, 51, 49, 1);
      .van-button__content {
        color: rgba(226, 51, 49, 1) !important;
      }
    }
    .to-payfor {
      width: 3.2rem;
      background: linear-gradient(111deg, #e23130 0%, #e23130 100%);
      color: #fff;
      .van-button__content {
        color: #fff !important;
      }
    }
  }

  .van-dialog .van-dialog__message {
    padding: 0.32rem 0.2rem;
  }
  .radius {
    padding: 0.02rem 0.1rem !important;
  }
  .pop {
    background-color: #fff !important;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    .van-loading {
      position: absolute;
      top: 50%;
      left: 50%;
      margin: -0.3rem 0 0 -0.3rem;
    }
  }
  .van-card__header {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/myorder/order.vue